import { Typography } from "@material-ui/core"

const Time = (props) => {

  return ( <>
    <Typography>
      Once you approve the final lyrics, our musicians get to work, and you’ll have your fully produced song within 7 days. But if patience isn’t your thing (or you need the song yesterday), we offer an expedited option to deliver it in just 48 hours. Because sometimes, true love, epic birthday surprises, or last-minute apologies just can’t wait.
    </Typography>
  </> )
}

export default Time
